import { Config } from '~/api/def/endpoints/dashboardEndpoint';

/**
 * Filter widget configs based on allowed widget ID patterns
 * @param configs - Array of widget configurations
 * @param allowedPatterns - Array of ID patterns to allow (e.g., ['risk-alerts', 'projected-risk-metrics'])
 * @param includeDynamic - Whether to include dynamic widgets (default: true)
 * @returns Filtered array of widget configs
 */
export const filterWidgetsByPattern = (
  configs: Config[],
  allowedPatterns: string[],
  includeDynamic: boolean = true,
): Config[] => {
  if (allowedPatterns.length === 0) {
    return configs; // No filter, return all
  }

  return configs.filter((config) => {
    // Optionally include dynamic widgets
    if (config.isDynamic) {
      return includeDynamic;
    }

    // Check if widget ID includes any allowed pattern
    return allowedPatterns.some((pattern) => config.id.includes(pattern));
  });
};
